/*
 * Overrides the theme's "estimated shipping" widget. Always computed in Serbian
 * time (Europe/Belgrade), regardless of the visitor's device clock/timezone.
 *   ship day = today if it's a working day before CUTOFF_HOUR, else next working day
 *   delivery = 1st and 2nd working day after the ship day
 * e.g. Mon 10:00 -> Tue-Wed; Mon 14:30 -> Wed-Thu; Fri 15:00 / Sat / Sun -> Tue-Wed.
 */
(function () {
  var CUTOFF_HOUR = 14;
  var TZ = 'Europe/Belgrade';
  // Serbian public holidays when couriers don't deliver (YYYY-MM-DD).
  var HOLIDAYS = [
    '2026-11-11',
    '2027-01-01', '2027-01-02', '2027-01-07', '2027-02-15', '2027-02-16',
    '2027-04-30', '2027-05-03', '2027-11-11'
  ];

  function belgradeNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      hour: +parts.hour
    };
  }

  function isWorkingDay(d) {
    var dow = d.getUTCDay();
    return dow !== 0 && dow !== 6 && HOLIDAYS.indexOf(d.toISOString().slice(0, 10)) === -1;
  }

  function nextWorkingDay(d) {
    var n = new Date(d.getTime());
    do { n.setUTCDate(n.getUTCDate() + 1); } while (!isWorkingDay(n));
    return n;
  }

  function deliveryWindow() {
    var now = belgradeNow();
    var ship = (isWorkingDay(now.date) && now.hour < CUTOFF_HOUR) ? now.date : nextWorkingDay(now.date);
    var start = nextWorkingDay(ship);
    return { start: start, end: nextWorkingDay(start) };
  }

  function formatDate(date, format, dayLabels, monthLabels) {
    var dayName = dayLabels[(date.getUTCDay() + 6) % 7] || ''; // labels are Monday-first
    var monthName = monthLabels[date.getUTCMonth()] || '';
    var day = date.getUTCDate();
    var month = date.getUTCMonth() + 1;

    switch (format) {
      case 'dd_mm_no_dot':
        return day + '/' + month;
      case 'dd_mm':
        return day + '.' + month + '.';
      case 'mm_dd':
        return month + '/' + day;
      case 'day_dd_mm':
      default:
        return dayName + ', ' + day + '. ' + monthName;
    }
  }

  function fixOne(el) {
    var wrapper = el.closest('dynamic-dates');
    if (!wrapper) return;

    var split = function (s) { return (s || '').split(',').map(function (x) { return x.trim(); }); };
    var dayLabels = split(wrapper.dataset.dayLabels);
    var monthLabels = split(wrapper.dataset.monthLabels);
    var format = wrapper.dataset.dateFormat || 'day_dd_mm';

    var w = deliveryWindow();
    var html = (el.dataset.text || '')
      .replace('[start_date]', formatDate(w.start, format, dayLabels, monthLabels))
      .replace('[end_date]', formatDate(w.end, format, dayLabels, monthLabels));
    if (html && el.innerHTML !== html) el.innerHTML = html;
  }

  function fixAll() {
    document
      .querySelectorAll('.estimated-shipping__text[data-dynamic-date="true"]')
      .forEach(fixOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAll);
  } else {
    fixAll();
  }
  // The theme's own <dynamic-dates> element may write its naive dates after us;
  // re-apply on load, after section re-renders, and when the tab regains focus
  // (a page left open past 14:00 must roll over to the next window).
  window.addEventListener('load', fixAll);
  document.addEventListener('shopify:section:load', fixAll);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) fixAll();
  });
  setInterval(fixAll, 60000);
  // Quick-add modals and other ajax-rendered product info insert new delivery
  // lines after load; rewrite them as soon as they appear.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      fixAll();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
